import React, {useEffect, useState} from 'react';
import {ArrowDownIcon, ArrowUpIcon} from '@heroicons/react/24/solid';
import api from '../../../../api/axios';
import Cookies from 'js-cookie';

const RevenueChartYPro = () => {
    const [comparisonValue, setComparisonValue] = useState(null);
    const [colorClass, setColorClass] = useState('text-gray-600');

    useEffect(() => {
        const fetchComparisonData = async () => {
            try {
                // Access Token aus Cookies abrufen
                const accessToken = Cookies.get('accessToken');

                if (!accessToken) {
                    console.warn('Kein Access Token gefunden. Die Anfrage wird nicht ausgeführt.');
                    return;
                }

                // Anfrage mit Authorization-Header durchführen
                const response = await api.get('/api/v1/revenue/current/year/comparison', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const value = parseFloat(response.data.comparison);
                setComparisonValue(value);

                // Festlegen der Farbe basierend auf dem Wert
                if (value < 0) {
                    setColorClass('text-red-600');
                } else {
                    setColorClass('text-green-600');
                }
            } catch (error) {
                console.error('Fehler beim Abrufen der Vergleichsdaten:', error);
                setComparisonValue(null); // Sicherstellen, dass bei einem Fehler nichts angezeigt wird
            }
        };

        fetchComparisonData();
    }, []);

    return (
        comparisonValue !== null ? (
            <div className={`${colorClass} flex items-center`}>
                <span className='font-bold'>{comparisonValue}%</span>
                {comparisonValue < 0 ? (
                    <ArrowDownIcon className='w-3 h-3 ml-1'/>
                ) : (
                    <ArrowUpIcon className='w-3 h-3 ml-1'/>
                )}
                <div className='font-color-6 font-light ml-1'>im Vergleich zu letztem Jahr zu diesem Zeitpunkt</div>
            </div>
        ) : null
    );
};

export default RevenueChartYPro;
